import { z } from 'zod';

import { ImporterStatus } from '@e-origin/shared';

export const BrokerListItemSchema = z.object({
  _id: z.string().optional(),
  name: z.string().optional(),
  idCard: z.any().optional(),
  businessLicense: z.any().optional(),
  eori: z.any().optional(),
  vat: z.any().optional(),
  status: z.nativeEnum(ImporterStatus).optional(),

  url: z.string().optional(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
  logo: z.string().optional(),

  address: z.any().optional(),
  proofs: z.array(z.any()).optional(),
  taxReturn: z.any().optional(),
  importRecords: z.any().optional(),
  poa: z.any().optional(),
  vatGuarantee: z.any().optional(),

  walletEndpoint: z.string().optional(),

  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),

  id: z.any().optional(),
  apiAccess: z.any().optional(),
  declarant: z.string().optional(),
  externalId: z.string().optional(),
  lastDeclarationsSync: z.coerce.date().optional(),
  __v: z.number().optional(),
  virtuals: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])).optional(),
});

export type BrokerListItem = z.infer<typeof BrokerListItemSchema>;
